(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instant-relief"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Optional: Add any interactive elements or animations
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mamun-video-slideshow"] && !window.DesignMode) return;
  try {
    
// This script runs in the Shopify theme editor to handle video changes
if (Shopify.designMode) {
  document.addEventListener('DOMContentLoaded', function() {
    // Function to handle video display
    function handleVideoDisplay() {
      const videoContainers = document.querySelectorAll('.mamun-video-container');
      videoContainers.forEach(container => {
        const video = container.querySelector('.mamun-native-video');
        const thumbnail = container.querySelector('.mamun-video-thumbnail');
        
        if (video && video.querySelector('source') && video.querySelector('source').src) {
          // Show video preview immediately
          if (thumbnail) {
            thumbnail.style.display = 'none';
          }
          
          video.style.display = 'block';
          video.style.opacity = '1';
          video.style.zIndex = '10';
          video.controls = true;
          video.muted = true;
          
          // Try to show the first frame
          video.currentTime = 0.1;
          video.classList.add('playing');
        }
      });
    }
    
    // Run on page load
    handleVideoDisplay();
    
    // Watch for changes to the DOM that might indicate a new video was added
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Check if any of the added nodes contain video elements
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && (node.classList.contains('mamun-video-container') || 
                node.querySelector && node.querySelector('.mamun-video-container'))) {
              // New video container detected, handle display
              setTimeout(handleVideoDisplay, 100);
            }
          });
        }
      });
    });
    
    // Start observing the document with the configured parameters
    observer.observe(document.body, { childList: true, subtree: true });
    
    // Also listen for Shopify editor events
    document.addEventListener('shopify:section:load', handleVideoDisplay);
    document.addEventListener('shopify:section:select', handleVideoDisplay);
    document.addEventListener('shopify:section:reorder', handleVideoDisplay);
    document.addEventListener('shopify:block:select', handleVideoDisplay);
    document.addEventListener('shopify:block:add', function() {
      // Use a delay to ensure the block is fully rendered
      setTimeout(handleVideoDisplay, 500);
    });
  });
}

  } catch(e) { console.error(e); }
})();
})();
